import React from "react";
import { Link } from "react-router-dom";

const ListWithHeadings = ({ listData, className }) => {
	return (
		<div className="grid col-span-12">
			{listData &&
				listData.map((item) => (
					<div className="w-full h-auto py-2" key={item.name}>
						<h3 className="text-md px-8 pb-5 text-green-500">{item.name}</h3>
						<ul>
							{item?.data &&
								item.data.map((subItem, index) => (
									<li
										key={index}
										className="flex items-center w-full py-2 px-4 hover:bg-slate-300/20">
										{subItem.icon && <subItem.icon className="mr-2 text-xl" />}
										<Link to={subItem.path} className="text-lg">{subItem.name}</Link>
									</li>
								))}
						</ul>
					</div>
				))}
		</div>
	);
};

export default ListWithHeadings;
